export default __webpack_public_path__ + "static/media/HRS.e93a9fbb.png";